import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { PromotionService } from '../promotion.service';
import { Promotion } from '../../../models/promotion.model';

@Component({
  selector: 'app-list-promotion',
  imports: [CommonModule, TableModule, ButtonModule, FormsModule, PaginatorModule],
  templateUrl: './list-promotion.component.html'
})
export class ListPromotionComponent implements OnInit {
  searchTerm = '';
  totalRecords = 0;
  promotions: Promotion[] = [];
  loading = false;
  first = 0;
  rows = 5;
  currentPage = 1;

  constructor(
    private router: Router,
    private promotionService: PromotionService
  ) {}

  ngOnInit(): void {
    this.getData();
  }

  getData(): void {
    this.loading = true;
    this.promotionService.getAll(this.searchTerm, this.currentPage, true).subscribe({
      next: data => {
        this.promotions = data.data ?? [];
        this.totalRecords = data.pagination?.totalRecords ?? 0;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onPageChange(event: { first?: number }): void {
    this.first = event.first ?? 0;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.getData();
  }

  createPromotion(): void {
    this.router.navigate(['/app/promotions/new']);
  }

  edit(p: Promotion): void {
    this.router.navigate(['/app/promotions/edit', p.id]);
  }

  remove(p: Promotion): void {
    if (!confirm(`Excluir a promoção #${p.id}?`)) {
      return;
    }
    this.promotionService.delete(p.id).subscribe({
      next: () => this.getData()
    });
  }

  discountLabel(type: number): string {
    return type === 1 ? 'Valor fixo (R$)' : 'Percentual (%)';
  }

  formatDate(iso: string): string {
    if (!iso) {
      return '';
    }
    const d = new Date(iso);
    return isNaN(d.getTime()) ? iso : d.toLocaleDateString('pt-BR');
  }
}
